import React, { Component } from "react";
import { connect } from "react-redux";

import { Translate } from "react-redux-i18n";

import POICard from "./POICard";

import { setAlert } from "../../../actions/alertActions";

import "../../../styles/components/map/chargerInfo/POIs.scss";

class POIs extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      pois: [],
    };
  }

  componentDidMount() {
    this._mounted = true;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.charger.properties.POIs !== state.pois) {
      return {
        pois: props.charger.properties.POIs,
      };
    }
    return null;
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <div id="POIs">
        <p>
          <Translate value="chargerPointFullDetails_pointsInterestNearby" />
        </p>
        <div className="poi-list">
          {this.state.pois
            .sort((a, b) => a.distance - b.distance)
            .map(poi => {
              if (poi.types.includes("point_of_interest") || poi.types.includes("establishment"))
                return (
                  <POICard key={poi.id} currentLocation={this.props.currentLocation} poi={poi} />
                );
              else return null;
            })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locale: state.i18n.locale,
});

export default connect(mapStateToProps, { setAlert })(POIs);
